var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.status)?_c('button',{staticClass:"btn btn-primary",class:{ 'disabled': _vm.disabledBtn, '': !_vm.disabledBtn },on:{"click":_vm.getCheckout}},[_vm._v("\n      Einfach und direkt bezahlen\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }